//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet, axiosPost } from '../../axios/axios.js'
import { EventBus } from '../../EventBus/EventBus.js'
import manba from 'manba'
import { filterFn, createFieldConfig } from '../../components/QSelectUtils.js'

export default {
  data: function () {
    return {
      formOpen: false,
      id: null,
      recordId: null,
      employeeNew: null,
      groupUnSuccess: null,
      employeeFieldConfig: createFieldConfig(this.getListEmployees),
      optionsUnSuccess: [
        {
          label: 'ДАВЛЕНИЕ',
          value: 'pressure'
        },
        {
          label: 'ОПЬЯНЕНИЕ',
          value: 'alcohol'
        },
        {
          label: 'СОСТОЯНИЕ ЗДОРОВЬЯ',
          value: 'health'
        }
      ],
      employee: null,
      shortRes: false,
      addBtnIsDisabled: true,
      resultBtnIsDisabled: false,
      medicAdmin: false,
      medicalExaminationKindName: null,
      warning: false
    }
  },
  created: function () {
    EventBus.$on('set-record-on-kind-trip', this.setRecordOnKindTrip)
  },
  beforeDestroy: function () {
    EventBus.$off('set-record-on-kind-trip', this.setRecordOnKindTrip)
  },
  methods: {
    onOpen: function () {
      this.shortRes = this.$d_hasRole('transportAdmin')
      this.medicAdmin = this.$d_hasRole('medicalAdmin')
      this.employeeNew = null
      if (this.id) {
        //  this.id = 1914
        this.getEmployee(this.id)
      } else {
        this.addBtnIsDisabled = false
        this.formOpen = true
      }
      // this.$d_showObjectCard(1914, 'employee')
    },
    saveResult: function (id, result) {
      const urlName = '/service/delta/journal/regularMedicalSchedule/setResult'
      const bodyFormData = new FormData()
      bodyFormData.set('id', id)
      bodyFormData.set('result', result)
      // --start временно
      // bodyFormData.set('force', true)
      // ---end
      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Результат по медосмотру сотрудника сохранен',
            progress: true,
            timeout: 3000
          })
          // this.$emit('update-list')
          // EventBus.$emit('update-', {})
          return Promise.resolve()
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка сохранения (Exception)',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.formOpen = false
        this.$nextTick(() => {
          this.$emit('update-list', { id: id, result: result })
        })
      })
    },
    onSuccess: function () {
      this.resultBtnIsDisabled = true
      this.saveResult(this.recordId, 'success')
    },
    onUnSuccess: function (state) {
      this.resultBtnIsDisabled = true
      this.saveResult(this.recordId, state)
    },
    getEmployee: function (id) {
      // const today = new Date()
      const urlName = '/service/delta/obj/properties?change=false&id=' + id + '&type=employee'
      // '/object/employee/' + id
      // '/service/delta/employee/get?id=' + id + '&searchFormat=true&workDate=' + today.getTime()
      this.employee = null
      this.medicalExaminationKindName = null
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          const res = response.data.result
          // $ctime  employmentDate    canBeDriver   consentToDrive   birthday
          this.$nextTick(() => {
            this.resultBtnIsDisabled = false
            this.employee = {
              imgUrl: '/service/delta/document/thumbnail/' + (res.image ? res.image[0].id : 0) + '/150/150',
              name: this.formatInitials(res.fio),
              positionName: res.position ? res.position[0].name : '',
              // isDriver: res.canBeDriver,
              departmentName: res.department ? res.department[0].name : '',
              birthday: res.birthday ? manba(res.birthday).format('DD-MM-YYYY') : ''
            }
            if (!this.recordId) {
              this.employeeNew = this.employee
            }
          })
          if (!this.recordId) {
            this.getRecordMedical()
          } else {
            this.$emit('get-record-on-kind-trip', [this.recordId])
          }
          // this.employee.workShiftName = res.workShift.name
          return Promise.resolve()
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка загрузки сотрудника',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки сотрудника'))
        }
      }).finally(() => {
        this.formOpen = true
        // this.employee = null
      })
    },
    formatInitials: function (name) {
      if (!name) {
        return ''
      }
      const arrFullName = name.split(' ')
      return arrFullName[0] + ' ' +
             (arrFullName[1] ? (arrFullName[1].substring(0, 1) + '.') : '') + ' ' +
             (arrFullName[2] ? (arrFullName[2].substring(0, 1) + '.') : '')
    },
    filterFnEmployee (val, update, abort) {
      return filterFn(val, update, abort, this.employeeFieldConfig)
    },
    setEmployee: function (val) {
      this.$refs.selectEmployee.resetValidation()
      if (!(val === null)) {
        this.id = val.id
        this.getEmployee(this.id)
        if (!this.recordId) {
          this.employeeNew = val
        } else {
          this.employeeNew = null
        }
      } else {
        this.id = null
        this.employeeNew = null
      }
      // this.$nextTick(() => {
      // this.$refs.selectEmployee.updateInputValue(this.employeeNew ? this.employeeNew : '', false)
      // })
      // this.employeeNew = null
      this.cancelField('selectEmployee')
    },
    cancelField: function (refKey) {
      const input = this.$refs[refKey].$refs.target
      if (input) {
        input.blur()
      }
    },
    getListEmployees: function () {
      const urlName = 'service/delta/employee/search?state=work&sort=name&dir=ASC'
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка загрузки списка сотрудников',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка сотрудников'))
        }
      })
    },
    onCreate: function () {
      const urlName = '/service/delta/journal/regularMedicalSchedule/create'
      const bodyFormData = new FormData()
      bodyFormData.set('employeeId', this.id)
      // const date = manba((new Date()).getTime()).format('YYYY-MM-DD 18:30:00')
      // bodyFormData.set('time', (new Date(date)).getTime())
      return axiosPost({
        url: urlName,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.recordId = response.data.result
          // console.log(response.data.result)
          this.$q.notify({
            type: 'positive',
            message: 'Сотрудник добавлен в список по медосмотру',
            progress: true,
            timeout: 3000
          })

          // this.$emit('update-list')
          // EventBus.$emit('update-', {})

          return Promise.resolve(this.recordId)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка сохранения (Exception)',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        // this.loading = false
        if (this.recordId) {
          this.employeeNew = null
          this.$refs.selectEmployee.updateInputValue('', false)
        }
      })
    },
    getRecordMedical: function () {
      // const date = manba((new Date()).getTime()).format('YYYY-MM-DD 18:30:00')
      const urlName = '/service/delta/journal/regularMedicalSchedule/getByEmployee?employeeId=' +
                      this.id
                      // + '&time=' + (new Date(date)).getTime()
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          // console.log('getRecordMedical', response.data)
          if (response.data.result.length == 1) {
            this.recordId = response.data.result[0].id
          } else {
            this.$emit('get-record-on-kind-trip', [response.data.result[0].id, response.data.result[1].id])
          }
          return Promise.resolve()
        },
        onFailure: (response) => {
          this.recordId = null
          return Promise.reject(response.message)
        },
        msgTarget: this
      }).finally(() => {
        if (this.recordId) {
          this.employeeNew = null
          if (this.$refs.selectEmployee) {
            this.$refs.selectEmployee.updateInputValue('', false)
          }
        } else {
          this.addBtnIsDisabled = false
        }
      })
    },
    onAddMedicalTest: function () {
      this.addBtnIsDisabled = true
      this.getRecordMedical()
      if (!this.recordId) {
        this.onCreate()
      }
      setTimeout(() => {
        this.addBtnIsDisabled = false
      }, 60000)
    },
    setRecordOnKindTrip: function (id, medicalExaminationKindName, warning = false) {
      this.recordId = id
      this.medicalExaminationKindName = medicalExaminationKindName
      this.warning = warning
    }
  }
}
